import { Fragment, type FunctionComponent, type MouseEvent } from 'react';
import {
    GAEventName,
    GAEventTrigger,
    GAFlowName,
    useGoogleAnalytics,
} from '../../../utils/googleAnalytics4AssetOnboardingFlow';
import { FormStepNavigation } from './EasyOnboardingDialog';
import SelectionTile from './SelectionTile';
import { ALL_ASSET_TYPE_TILES } from './configuration/assetTypeTileConfig';
import type { AssetTypeTile } from './configuration/types';
import { AssetType } from '../types';

interface FormStepSelectAssetTypeProps {
    setSelectedAssetType: (value: AssetTypeTile) => void;
    handleFormStepNavigation: (goto: FormStepNavigation, e?: MouseEvent) => void;
    isLatamTenant?: boolean;
}

export const FormStepSelectAssetType: FunctionComponent<FormStepSelectAssetTypeProps> = (
    props: FormStepSelectAssetTypeProps
) => {
    const { setSelectedAssetType, handleFormStepNavigation } = props;
    const { dataLayerPush } = useGoogleAnalytics();

    const types = props.isLatamTenant
        ? ALL_ASSET_TYPE_TILES
        : ALL_ASSET_TYPE_TILES.filter(value => value.assetType !== AssetType.car);

    return (
        <div
            className={`display-grid grid-cols-2 ${types.length > 4 ? 'grid-cols-3-sm' : ''} gap-10-xs gap-20 padding-20`}
        >
            {types.map((item, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: suppress out of convenience during migration to biome
                <Fragment key={item.assetType + index}>
                    <SelectionTile
                        show='image'
                        name={item.assetType}
                        image={item.logo}
                        animationDelay={index * 0.1}
                        tileType='default'
                        data-cy={`selection-tile-${item.assetType}`}
                        onClick={e => {
                            dataLayerPush({
                                trigger: GAEventTrigger.click,
                                event: GAEventName.selectAssetType,
                                element_name: item.assetType,
                                flow_name: GAFlowName.easyOnboardingFlow,
                            });
                            setSelectedAssetType(item);
                            handleFormStepNavigation(FormStepNavigation.next, e);
                        }}
                    />
                </Fragment>
            ))}
        </div>
    );
};
